import { render, staticRenderFns } from "./TabStaffLeave.vue?vue&type=template&id=e519cdf0"
import script from "./TabStaffLeave.vue?vue&type=script&lang=js"
export * from "./TabStaffLeave.vue?vue&type=script&lang=js"
import style0 from "./TabStaffLeave.vue?vue&type=style&index=0&id=e519cdf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports